import {storeSet, authPageCheck} from "@/mixins/Auth.js"

function setViewResolver(component) {
    return require('../views/' + component).default;
}

//
export default [
    {
        path: '/',
        component: setViewResolver('Home'),
        name: 'Home',
        beforeEnter: storeSet,
        meta: {
            title: '회원 관리',
            sideName: '회원 관리',
            sideHidden: true,
            icon_name: 'member',
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true, levelCheck: true}
        },
    },
    {
        path: '/auth',
        component: setViewResolver('RouteView'),
        name: 'Auth',
        meta: {sideHidden: true,},
        children: [
            {
                path: '',
                name: 'AuthLogin',
                component: setViewResolver('auth/Login'),
                meta: {title: '로그인'}
            }
        ]
    },
    {
        path: '/playerTest',
        component: setViewResolver('playerTest'),
        name: 'playerTest',
        beforeEnter: storeSet,
        meta: {sideHidden: true},
    },
    {
        path: '/member',
        component: setViewResolver('RouteView'),
        name: 'Member',
        beforeEnter: storeSet,
        meta: {
            title: '회원 관리',
            sideName: '회원 관리',
            icon_name: 'member',
            level: [2, 3],
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true, levelCheck: true},
        },
        children: [
            {
                path: '',
                component: setViewResolver('member/Member'),
                beforeEnter: storeSet,
                meta: {
                    title: '회원 리스트',
                    sideName: '회원 리스트',
                    name: 'member',
                    level: [2, 3],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                },
            }, {
                path: 'create',
                component: setViewResolver('member/MemberCreate'),
                name: 'MemberCreate',
                beforeEnter: storeSet,
                meta: {
                    title: '회원 등록',
                    sideName: '회원 등록',
                    name: 'MemberCreate',
                    detail: true,
                    sideHidden: true,
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true}
                },
            }, {
                path: 'profile',
                name: 'ProfileBorder',
                beforeEnter: storeSet,
                component: setViewResolver('member/MemberProfile'),
                meta: {
                    title: '프로필 테두리 리스트',
                    sideName: '프로필 테두리 리스트',
                    name: 'ProfileBorder',
                    level: [2, 3],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                },
            }, {
                path: 'profile/create',
                component: setViewResolver('member/MemberProfileCreate'),
                name: 'MemberProfileCreate',
                beforeEnter: storeSet,
                meta: {
                    title: '프로필 테두리 발급',
                    sideName: '프로필 테두리 발급',
                    sideHidden: true,
                    name: 'MemberProfileCreate',
                    level: [2, 3],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                },
            }, {
                path: 'profile/:p_idx',
                component: setViewResolver('member/MemberProfileDetail'),
                name: 'MemberProfileDetail',
                beforeEnter: storeSet,
                meta: {
                    title: '프로필 테두리 수정',
                    sideName: '',
                    sideHidden: true,
                    name: 'MemberProfileDetail',
                    detail: true,
                    level: [2, 3],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            }, {
                path: 'deny',
                name: 'DenyMember',
                beforeEnter: storeSet,
                component: setViewResolver('member/MemberDeny'),
                meta: {
                    title: '탈퇴 회원 관리',
                    sideName: '탈퇴 회원 관리',
                    name: 'DenyMember',
                    level: [2, 3],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                },
            }, {
                path: 'log',
                name: 'MemberLog',
                beforeEnter: storeSet,
                component: setViewResolver('member/Log'),
                meta: {
                    title: '회원 활동 내역',
                    sideName: '회원 활동 내역',
                    name: 'MemberLog',
                    level: [2, 3],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            }, {
                path: ':mb_no',
                component: setViewResolver('member/MemberDetail'),
                name: 'MemberDetail',
                beforeEnter: storeSet,
                meta: {
                    title: '회원 수정',
                    sideName: '',
                    sideHidden: true,
                    name: 'Member',
                    detail: true,
                    level: [2, 3],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            },
        ]
    },
    {
        path: '/feed',
        component: setViewResolver('RouteView'),
        name: 'Feed',
        beforeEnter: storeSet,
        meta: {
            title: '',
            sideName: '피드 관리',
            icon_name: 'book',
            level: [2, 3, 5],
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true, levelCheck: true},
        },
        children: [
            {
                path: '',
                name: 'Feed',
                beforeEnter: storeSet,
                component: setViewResolver('feed/Feed'),
                meta: {
                    title: '피드 리스트',
                    sideName: '피드 리스트',
                    name: 'custom',
                    level: [2, 3, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                },
            },/*{
                path: 'today',
                name: 'Today',
                beforeEnter: storeSet,
                component: setViewResolver('today/Today'),
                meta: {title: '오늘게시물 리스트', sideName: '오늘게시물 리스트', name: 'custom', level: [2, 3, 5], authRequired: true, storeRequired: true, storeConfig:{userInfo:true, levelCheck: true},},
            },{
                path: 'today/:wr_id',
                component: setViewResolver('today/TodayDetail'),
                name: 'TodayDetail',
                beforeEnter: storeSet,
                meta: {title: '오늘 게시물 상세', sideName: '', sideHidden: true, name: 'TodayDetail', detail: true, level: [2, 3, 5], authRequired: true, storeRequired: true, storeConfig:{userInfo:true, levelCheck: true},}
            },{
                path: 'todayBanner',
                name: 'todayBanner',
                beforeEnter: storeSet,
                component: setViewResolver('todayBanner/TodayBanner'),
                meta: {title: '오늘배너 리스트', sideName: '오늘배너 리스트', name: 'todayBanner', level: [2, 3, 5], authRequired: true, storeRequired: true, storeConfig:{userInfo:true, levelCheck: true},},
            },{
                path: 'todayBanner/create',
                name: 'TodayBannerCreate',
                beforeEnter: storeSet,
                component: setViewResolver('todayBanner/TodayBannerCreate'),
                meta: {title: '오늘배너 등록/수정', sideName: '오늘배너 등록/수정', sideHidden: true,name: 'TodayBannerCreate', level: [2, 3, 5], authRequired: true, storeRequired: true, storeConfig:{userInfo:true, levelCheck: true},},
            },{
                path : 'todayBanner/:b_idx',
                component: setViewResolver('todayBanner/TodayBannerDetail'),
                name: 'TodayBannerDetail',
                beforeEnter: storeSet,
                meta: {title: '오늘 배너 수정', sideName: '수정', name: 'TodayBannerDetail', detail: true, sideHidden: true, level: [2, 4], authRequired: true, storeRequired: true, storeConfig:{userInfo:true, levelCheck: true},},
            },*/{
                path: 'detail/:wr_id',
                component: setViewResolver('feed/FeedDetail'),
                name: 'FeedDetail',
                beforeEnter: storeSet,
                meta: {
                    title: '피드 수정',
                    sideName: '',
                    sideHidden: true,
                    name: 'FeedDetail',
                    detail: true,
                    level: [2, 3, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            },
        ]
    },
    {
        path: '/item',
        component: setViewResolver('RouteView'),
        beforeEnter: storeSet,
        meta: {
            title: '상품',
            sideName: '상품관리',
            icon_name: 'shopping-bag',
            name: 'Item',
            level: [2, 5],
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true, levelCheck: true},
        },
        children: [
            {
                path: 'create',
                component: setViewResolver('item/ItemCreate'),
                beforeEnter: storeSet,
                meta: {
                    title: '상품 등록',
                    sideName: '상품등록',
                    sideHidden: true,
                    name: 'ItemNormal',
                    level: [2, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            },
            {
                path: '',
                component: setViewResolver('item/Item'),
                beforeEnter: storeSet,
                meta: {
                    title: '상품 목록',
                    sideName: '상품목록',
                    name: 'ItemNormal',
                    level: [2, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                },
                children: [
                    {
                        path: ':i_idx',
                        component: setViewResolver('item/ItemDetail'),
                        beforeEnter: storeSet,
                        meta: {
                            title: '상품상세',
                            sideName: '',
                            name: 'ItemNormal',
                            sideHidden: true,
                            detail: true,
                            level: [2, 5],
                            authRequired: true,
                            storeRequired: true,
                            storeConfig: {userInfo: true, levelCheck: true},
                        },
                    },
                    {
                        path: 'relate/:i_idx/use',
                        component: setViewResolver('item/ItemRelate'),
                        beforeEnter: storeSet,
                        meta: {
                            title: '추천 아이템',
                            sideName: '',
                            name: 'ItemRelate',
                            sideHidden: true,
                            detail: true,
                            level: [2, 5],
                            authRequired: true,
                            storeRequired: true,
                            storeConfig: {userInfo: true, levelCheck: true},
                        },
                    },
                    {
                        path: 'relate/:i_idx/:i_model',
                        component: setViewResolver('item/ItemRelate'),
                        beforeEnter: storeSet,
                        meta: {
                            title: '추천 아이템',
                            sideName: '',
                            name: 'ItemRelate',
                            sideHidden: true,
                            detail: true,
                            level: [2, 5],
                            authRequired: true,
                            storeRequired: true,
                            storeConfig: {userInfo: true, levelCheck: true},
                        },
                    },

                ]
            },
        ]
    },
    {
        path: '/order', // 주문관리
        component: setViewResolver('RouteView'),
        name: 'beforeDeposit',
        beforeEnter: storeSet,
        meta: {
            title: '주문관리',
            sideName: '주문관리',
            icon_name: 'cart',
            name: 'Item',
            level: [2, 5],
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true, levelCheck: true},
        },
        children: [
            /*{
                path: 'before',
                component: setViewResolver('order/beforeDeposit'),
                beforeEnter: storeSet,
                meta: {title: '입금전 관리', sideName: '입금전 관리', sideHidden: false, name: '입금전 관리', level: [2,5], authRequired: true, storeRequired: true, storeConfig:{userInfo:true, levelCheck: true},}
            },*/
            {
                path: 'before/:o_idx',
                component: setViewResolver('order/beforeDepositDetail'),
                beforeEnter: storeSet,
                meta: {
                    title: '주문정보',
                    sideName: '주문정보',
                    sideHidden: true,
                    name: '주문정보',
                    level: [2, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            },
            {
                path: 'complete',
                component: setViewResolver('order/orderComplete'),
                beforeEnter: storeSet,
                meta: {
                    title: '결제완료 관리',
                    sideName: '결제완료 관리',
                    sideHidden: false,
                    name: '결제완료 관리',
                    level: [2, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            },
            {
                path: 'complete/:idx',
                component: setViewResolver('order/orderCompleteDetail'),
                beforeEnter: storeSet,
                meta: {
                    title: '주문정보',
                    sideName: '주문정보',
                    sideHidden: true,
                    name: '주문정보',
                    level: [2, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            },
            {
                path: 'itemready',
                component: setViewResolver('order/orderItemReady'),
                beforeEnter: storeSet,
                meta: {
                    title: '상품준비중 관리',
                    sideName: '상품준비중 관리',
                    sideHidden: false,
                    name: '상품준비중 관리',
                    level: [2, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            },
            {
                path: 'itemready/:idx',
                component: setViewResolver('order/orderItemReadyDetail'),
                beforeEnter: storeSet,
                meta: {
                    title: '주문정보',
                    sideName: '주문정보',
                    sideHidden: true,
                    name: '주문정보',
                    level: [2, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            },
            {
                path: 'preparing',
                component: setViewResolver('order/preparing'),
                beforeEnter: storeSet,
                meta: {
                    title: '배송준비중 관리',
                    sideName: '배송준비중 관리',
                    sideHidden: false,
                    name: '배송준비중 관리',
                    level: [2, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            },
            {
                path: 'preparing/:idx',
                component: setViewResolver('order/preparingDetail'),
                beforeEnter: storeSet,
                meta: {
                    title: '주문정보',
                    sideName: '주문정보',
                    sideHidden: true,
                    name: '주문정보',
                    level: [2, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            },
            {
                path: 'shipping',
                component: setViewResolver('order/shipping'),
                beforeEnter: storeSet,
                meta: {
                    title: '배송중 관리',
                    sideName: '배송중 관리',
                    sideHidden: false,
                    name: '배송중 관리',
                    level: [2, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            },
            {
                path: 'shipping/done',
                component: setViewResolver('order/shippingDone'),
                beforeEnter: storeSet,
                meta: {
                    title: '배송완료 관리',
                    sideName: '배송완료 관리',
                    sideHidden: false,
                    name: '배송완료 관리',
                    level: [2, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            },
            {
                path: 'shipping/:idx',
                component: setViewResolver('order/shippingDetail'),
                beforeEnter: storeSet,
                meta: {
                    title: '주문정보',
                    sideName: '주문정보',
                    sideHidden: true,
                    name: '주문정보',
                    level: [2, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            },
            {
                path: 'shipping/done/:idx',
                component: setViewResolver('order/shippingDoneDetail'),
                beforeEnter: storeSet,
                meta: {
                    title: '주문정보',
                    sideName: '주문정보',
                    sideHidden: true,
                    name: '주문정보',
                    level: [2, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            },
            {
                path: 'after',
                component: setViewResolver('RouteView'),
                beforeEnter: storeSet,
                meta: {
                    title: '취소/교환/환불',
                    sideName: '취소/교환/환불',
                    sideHidden: false,
                    name: '취소/교환/환불',
                    level: [2, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                },
                children: [
                    {
                        path: 'cancel',
                        component: setViewResolver('order/orderCancel'),
                        beforeEnter: storeSet,
                        meta: {
                            title: '취소 관리',
                            sideName: '취소 관리',
                            sideHidden: false,
                            name: '취소 관리',
                            level: [2, 5],
                            authRequired: true,
                            storeRequired: true,
                            storeConfig: {userInfo: true, levelCheck: true},
                        }
                    },
                    {
                        path: 'cancel/:idx',
                        component: setViewResolver('order/orderCancelDetail'),
                        beforeEnter: storeSet,
                        meta: {
                            title: '주문정보',
                            sideName: '주문정보',
                            sideHidden: true,
                            name: '주문정보',
                            level: [2, 5],
                            authRequired: true,
                            storeRequired: true,
                            storeConfig: {userInfo: true, levelCheck: true},
                        }
                    },
                    {
                        path: 'exchange',
                        component: setViewResolver('order/orderExchange'),
                        beforeEnter: storeSet,
                        meta: {
                            title: '교환 관리',
                            sideName: '교환 관리',
                            sideHidden: false,
                            name: '교환 관리',
                            level: [2, 5],
                            authRequired: true,
                            storeRequired: true,
                            storeConfig: {userInfo: true, levelCheck: true},
                        }
                    },
                    {
                        path: 'exchange/:idx',
                        component: setViewResolver('order/orderExchangeDetail'),
                        beforeEnter: storeSet,
                        meta: {
                            title: '주문정보',
                            sideName: '주문정보',
                            sideHidden: true,
                            name: '주문정보',
                            level: [2, 5],
                            authRequired: true,
                            storeRequired: true,
                            storeConfig: {userInfo: true, levelCheck: true},
                        }
                    },
                    {
                        path: 'refund',
                        component: setViewResolver('order/orderRefund'),
                        beforeEnter: storeSet,
                        meta: {
                            title: '환불 관리',
                            sideName: '환불 관리',
                            sideHidden: false,
                            name: '환불 관리',
                            level: [2, 5],
                            authRequired: true,
                            storeRequired: true,
                            storeConfig: {userInfo: true, levelCheck: true},
                        }
                    },
                    {
                        path: 'refund/:idx',
                        component: setViewResolver('order/orderRefundDetail'),
                        beforeEnter: storeSet,
                        meta: {
                            title: '주문정보',
                            sideName: '주문정보',
                            sideHidden: true,
                            name: '주문정보',
                            level: [2, 5],
                            authRequired: true,
                            storeRequired: true,
                            storeConfig: {userInfo: true, levelCheck: true},
                        }
                    },
                ]
            },
        ]
    },
    {
        path: '/suggest',
        component: setViewResolver('RouteView'),
        name: 'suggestWord',
        beforeEnter: storeSet,
        meta: {
            title: '추천',
            sideName: '추천관리',
            icon_name: 'book',
            name: 'Item',
            level: [2, 5],
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true, levelCheck: true},
        },
        children: [
            {
                path: 'word',
                component: setViewResolver('suggest/SuggestWord'),
                beforeEnter: storeSet,
                meta: {
                    title: '추천 검색어 목록',
                    sideName: '추천 검색어 목록',
                    sideHidden: false,
                    name: '추천 검색어 목록',
                    level: [2, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            },
            {
                path: 'word/create',
                component: setViewResolver('suggest/SuggestWordCreate'),
                beforeEnter: storeSet,
                meta: {
                    title: '추천 검색어 등록',
                    sideName: '',
                    sideHidden: true,
                    name: '추천 검색어 등록',
                    level: [2, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            },
            {
                path: 'word/:idx',
                component: setViewResolver('suggest/SuggestWordDetail'),
                beforeEnter: storeSet,
                meta: {
                    title: '추천 검색어 상세',
                    sideName: '',
                    sideHidden: true,
                    name: '추천 검색어 상세',
                    level: [2, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            },
            {
                path: 'style',
                component: setViewResolver('style/Style'),
                beforeEnter: storeSet,
                meta: {
                    title: '스타일 목록',
                    sideName: '스타일 목록',
                    sideHidden: false,
                    name: '스타일 목록',
                    level: [2, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                },
            },
            {
                path: 'style/:idx',
                component: setViewResolver('style/StyleDetail'),
                beforeEnter: storeSet,
                meta: {
                    title: '스타일 수정',
                    sideName: '',
                    sideHidden: true,
                    name: '스타일 수정',
                    level: [2, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                },
            },
            {
                path: 'example',
                component: setViewResolver('example/ExampleWord'),
                beforeEnter: storeSet,
                meta: {
                    title: '검색 문구 목록',
                    sideName: '검색 문구 목록',
                    sideHidden: false,
                    name: '검색 문구 목록',
                    level: [2, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                },
            },
            {
                path: 'example/create',
                component: setViewResolver('example/ExampleWordCreate'),
                beforeEnter: storeSet,
                meta: {
                    title: '검색 문구 등록',
                    sideName: '',
                    sideHidden: true,
                    name: '검색 문구 등록',
                    level: [2, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            },
            {
                path: 'example/:idx',
                component: setViewResolver('example/ExampleWordDetail'),
                beforeEnter: storeSet,
                meta: {
                    title: '검색 문구 수정',
                    sideName: '',
                    sideHidden: true,
                    name: '검색 문구 수정',
                    level: [2, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            },
        ]
    },
    {
        path: '/magazine',
        component: setViewResolver('RouteView'),
        name: 'Theme',
        beforeEnter: storeSet,
        meta: {
            title: '매거진',
            sideName: '매거진',
            icon_name: 'book',
            name: 'Theme',
            level: [2, 4, 5],
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true, levelCheck: true},
        },
        children: [
            {
                path: 'create',
                component: setViewResolver('theme/ThemeWrite'),
                name: 'ThemeWrite',
                beforeEnter: storeSet,
                meta: {
                    title: '매거진 등록',
                    sideName: '등록',
                    name: 'ThemeWrite',
                    detail: true,
                    sideHidden: true,
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                },
            }, {
                path: ':p_idx/item',
                component: setViewResolver('theme/ThemeItem'),
                name: 'ThemeItem',
                beforeEnter: storeSet,
                meta: {
                    title: '연관 상품 등록',
                    sideName: '',
                    sideHidden: true,
                    name: 'Theme',
                    detail: true,
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                },
            }, {
                path: ':p_idx/recommend',
                component: setViewResolver('theme/ThemeRecommend'),
                name: 'ThemeRecommend',
                beforeEnter: storeSet,
                meta: {
                    title: '추천 매거진 등록',
                    sideName: '',
                    sideHidden: true,
                    name: 'ThemeRecommend',
                    detail: true,
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            }, {
                path: '',
                component: setViewResolver('theme/Theme'),
                name: 'ThemeList',
                beforeEnter: storeSet,
                meta: {
                    title: '매거진 목록',
                    sideName: '매거진 목록',
                    name: 'Theme',
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            }, {
                path: 'ad',
                component: setViewResolver('theme/AdMagazine'),
                name: 'AdList',
                beforeEnter: storeSet,
                meta: {
                    title: '광고 매거진 목록',
                    sideName: '광고 매거진 목록',
                    name: 'Theme',
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            }, {
                path: 'ad/create',
                component: setViewResolver('theme/AdMagazineWrite'),
                name: 'AdMagazineWrite',
                beforeEnter: storeSet,
                meta: {
                    title: '광고 매거진 등록',
                    sideName: '등록',
                    name: 'ThemeWrite',
                    detail: true,
                    sideHidden: true,
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                },
            }, {
                path: 'ad/:idx',
                component: setViewResolver('theme/AdMagazineDetail'),
                name: 'AdMagazineUpdate',
                beforeEnter: storeSet,
                meta: {
                    title: '광고 매거진 수정',
                    sideName: '수정',
                    name: 'ThemeWrite',
                    detail: true,
                    sideHidden: true,
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                },
            }, {
                path: 'event',
                component: setViewResolver('event/Event'),
                name: 'EventList',
                beforeEnter: storeSet,
                meta: {
                    title: '이벤트 배너 목록',
                    sideName: '이벤트배너',
                    name: 'EventList',
                    level: [2, 4],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                },
            }, {
                path: 'event/create',
                component: setViewResolver('event/EventCreate'),
                name: 'EventCreate',
                beforeEnter: storeSet,
                meta: {
                    title: '이벤트 배너 등록',
                    sideName: '등록',
                    name: 'EventCreate',
                    detail: true,
                    sideHidden: true,
                    level: [2, 4],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                },
            }, {
                path: 'event/:e_idx',
                component: setViewResolver('event/EventDetail'),
                name: 'EventUpdate',
                beforeEnter: storeSet,
                meta: {
                    title: '이벤트 배너 수정',
                    sideName: '수정',
                    name: 'EventUpdate',
                    detail: true,
                    sideHidden: true,
                    level: [2, 4],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                },
            }, {
                path: 'hashtag',
                component: setViewResolver('theme/HashTag'),
                name: 'HashTag',
                beforeEnter: storeSet,
                meta: {
                    title: '해시태그 목록',
                    sideName: '해시태그 목록',
                    name: 'HashTag',
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                },
            }, {
                path: 'hashtag/create',
                component: setViewResolver('theme/HashtagWrite'),
                name: 'HashtagWrite',
                beforeEnter: storeSet,
                meta: {
                    title: '해시태그 등록',
                    name: 'HashtagWrite',
                    detail: true,
                    sideHidden: true,
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                },
            }, {
                path: 'hashtag/:ph_idx',
                component: setViewResolver('theme/HashtagDetail'),
                name: 'HashtagDetail',
                beforeEnter: storeSet,
                meta: {
                    title: '해시태그 수정',
                    sideHidden: true,
                    name: 'HashtagDetail',
                    detail: true,
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            }, {
                path: 'category',
                component: setViewResolver('theme/Category'),
                name: 'Category',
                beforeEnter: storeSet,
                meta: {
                    title: '카테고리 목록',
                    sideName: '카테고리 목록',
                    name: 'Category',
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                },
            }, {
                path: 'category/create',
                component: setViewResolver('theme/CategoryWrite'),
                name: 'CategoryWrite',
                beforeEnter: storeSet,
                meta: {
                    title: '카테고리 등록',
                    name: 'CategoryWrite',
                    detail: true,
                    sideHidden: true,
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                },
            }, {
                path: 'category/:pc_idx',
                component: setViewResolver('theme/CategoryDetail'),
                name: 'CategoryDetail',
                beforeEnter: storeSet,
                meta: {
                    title: '카테고리 수정',
                    name: 'CategoryDetail',
                    detail: true,
                    sideHidden: true,
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            },/*{
                path: 'theme',
                component: setViewResolver('theme/MagazinTheme'),
                name: 'MagazinTheme',
                beforeEnter: storeSet,
                meta: {title: '테마 목록', sideName: '테마 목록', name: 'MagazinTheme', level: [2, 4, 5], authRequired: true, storeRequired: true, storeConfig:{userInfo:true, levelCheck: true},},
            },{
                path: 'theme/create',
                component: setViewResolver('theme/MagazinThemeWrite'),
                name: 'MagazinThemeWrite',
                beforeEnter: storeSet,
                meta: {title: '테마 등록', sideHidden: true, name: 'MagazinThemeWrite', detail: true, level: [2, 4, 5], authRequired: true, storeRequired: true, storeConfig:{userInfo:true, levelCheck: true},},
            },{
                path: 'theme/:pt_idx',
                component: setViewResolver('theme/MagazinThemeDetail'),
                name: 'MagazinThemeDetail',
                beforeEnter: storeSet,
                meta: {title: '테마 수정', sideHidden: true, name: 'MagazinThemeDetail', detail: true, level: [2, 4, 5], authRequired: true, storeRequired: true, storeConfig:{userInfo:true, levelCheck: true},}
            },*/{
                path: ':p_idx',
                component: setViewResolver('theme/ThemeDetail'),
                name: 'ThemeDetail',
                beforeEnter: storeSet,
                meta: {
                    title: '매거진 수정',
                    sideName: '',
                    sideHidden: true,
                    name: 'Theme',
                    detail: true,
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            },
        ]
    },
    {
        path: '/lookbook',
        component: setViewResolver('RouteView'),
        name: 'Lookbook',
        beforeEnter: storeSet,
        meta: {
            title: '플레이옷',
            sideName: '플레이옷',
            icon_name: 'book',
            name: 'Theme',
            level: [2, 4, 5],
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true, levelCheck: true},
        },
        children: [
            {
                path: '',
                component: setViewResolver('lookbook/Lookbook'),
                name: 'LookbookList',
                beforeEnter: storeSet,
                meta: {
                    title: '플레이옷 목록',
                    sideName: '플레이옷목록',
                    name: 'Theme',
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            },
            {
                path: 'create',
                component: setViewResolver('lookbook/LookbookWrite'),
                name: 'LookbookWrite',
                beforeEnter: storeSet,
                meta: {
                    title: '플레이옷 등록',
                    sideName: '등록',
                    name: 'ThemeWrite',
                    detail: true,
                    sideHidden: true,
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                },
            },
            {
                path: 'excel',
                component: setViewResolver('lookbook/LookbookExcel'),
                name: 'LookbookExcel',
                beforeEnter: storeSet,
                meta: {
                    title: '플레이옷 엑셀 등록',
                    sideName: '플레이옷 엑셀 등록',
                    name: 'LookbookExcel',
                    detail: true,
                    sideHidden: true,
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                },
            },
            {
                path: 'item/excel',
                component: setViewResolver('lookbook/LookbookItemExcel'),
                name: 'LookbookItemExcel',
                beforeEnter: storeSet,
                meta: {
                    title: '상품 엑셀 등록',
                    sideName: '상품 엑셀 등록',
                    name: 'LookbookItemExcel',
                    detail: true,
                    sideHidden: true,
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                },
            },
            {
                path: 'hash',
                component: setViewResolver('lookbook/LokkbookHash'),
                name: 'LokkbookHash',
                beforeEnter: storeSet,
                meta: {
                    title: '해시태그 목록',
                    sideName: '해시태그 목록',
                    name: 'HashTag',
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                },
            }, {
                path: 'hashtag/create',
                component: setViewResolver('lookbook/LookbookHashWrite'),
                name: 'LookbookHashWrite',
                beforeEnter: storeSet,
                meta: {
                    title: '해시태그 등록',
                    name: 'LookbookHashWrite',
                    detail: true,
                    sideHidden: true,
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                },
            }, {
                path: 'hashtag/:lh_idx',
                component: setViewResolver('lookbook/LookbookHashDetail'),
                name: 'LookbookHashDetail',
                beforeEnter: storeSet,
                meta: {
                    title: '해시태그 수정',
                    sideHidden: true,
                    name: 'LookbookHashDetail',
                    detail: true,
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            }, {
                path: 'channel',
                component: setViewResolver('lookbook/LokkbookChannel'),
                name: 'LokkbookChannel',
                beforeEnter: storeSet,
                meta: {
                    title: '채널 목록',
                    sideName: '채널 목록',
                    name: 'Channel',
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                },
            }, {
                path: 'channel/create',
                component: setViewResolver('lookbook/LokkbookChannelWrite'),
                name: 'LokkbookChannelWrite',
                beforeEnter: storeSet,
                meta: {
                    title: '채널 등록',
                    name: 'LokkbookChannelWrite',
                    detail: true,
                    sideHidden: true,
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                },
            }, {
                path: 'channel/:idx',
                component: setViewResolver('lookbook/LokkbookChannelUpdate'),
                name: 'LokkbookChannelUpdate',
                beforeEnter: storeSet,
                meta: {
                    title: '채널 수정',
                    name: 'LokkbookChannelUpdate',
                    detail: true,
                    sideHidden: true,
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                },
            }, {
                path: 'theme',
                component: setViewResolver('lookbook/LookbookTheme'),
                name: 'LookbookTheme',
                beforeEnter: storeSet,
                meta: {
                    title: '테마 목록',
                    sideName: '테마 목록',
                    name: 'LookbookTheme',
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                },
            }, {
                path: 'theme/create',
                component: setViewResolver('lookbook/LookbookThemeWrite'),
                name: 'LookbookThemeWrite',
                beforeEnter: storeSet,
                meta: {
                    title: '테마 등록',
                    sideHidden: true,
                    name: 'LookbookThemeWrite',
                    detail: true,
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                },
            }, {
                path: 'theme/:lt_idx',
                component: setViewResolver('lookbook/LookbookThemeDetail'),
                name: 'LookbookThemeDetail',
                beforeEnter: storeSet,
                meta: {
                    title: '테마 수정',
                    sideHidden: true,
                    name: 'LookbookThemeDetail',
                    detail: true,
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            }, {
                path: ':l_idx',
                component: setViewResolver('lookbook/LookbookDetail'),
                name: 'LookbookDetail',
                beforeEnter: storeSet,
                meta: {
                    title: '플레이옷 수정',
                    sideName: '',
                    sideHidden: true,
                    name: 'LookbookDetail',
                    detail: true,
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            }, {
                path: ':l_idx/recommend',
                component: setViewResolver('lookbook/LookbookRecommend'),
                name: 'ThemeRecommend',
                beforeEnter: storeSet,
                meta: {
                    title: '추천 플레이옷 등록',
                    sideName: '',
                    sideHidden: true,
                    name: 'ThemeRecommend',
                    detail: true,
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            },
            {
                path: ':l_idx/use',
                component: setViewResolver('lookbook/LookbookUseItem'),
                name: 'LookbookUseItem',
                beforeEnter: storeSet,
                meta: {
                    title: '사용한 상품',
                    sideName: '',
                    sideHidden: true,
                    name: 'LookbookUseItem',
                    detail: true,
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            },
        ]
    },
    {
        path: '/brand',
        component: setViewResolver('RouteView'),
        name: 'Brand',
        beforeEnter: storeSet,
        meta: {
            title: '브랜드관',
            sideName: '브랜드관',
            icon_name: 'brand',
            name: 'Brand',
            level: [2, 4, 5],
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true, levelCheck: true},
        },
        children: [
            {
                path: '',
                component: setViewResolver('brand/Brand'),
                name: 'BrandList',
                beforeEnter: storeSet,
                meta: {
                    title: '브랜드관',
                    sideName: '브랜드관',
                    name: 'BrandList',
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            },
            {
                path: 'create',
                component: setViewResolver('brand/BrandCreate'),
                name: 'BrandCreate',
                beforeEnter: storeSet,
                meta: {
                    title: '브랜드관 생성',
                    sideName: '브랜드관 생성',
                    name: 'BrandCreate',
                    sideHidden: true,
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            },
            {
                path: 'adver',
                component: setViewResolver('brand/BrandAdver'),
                name: 'BrandAdver',
                beforeEnter: storeSet,
                meta: {
                    title: '브랜드 광고',
                    sideName: '브랜드 광고',
                    name: 'BrandAdver',
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            },
            {
                path: ':b_idx',
                component: setViewResolver('brand/BrandDetail'),
                name: 'BrandDetail',
                beforeEnter: storeSet,
                meta: {
                    title: '브랜드관 상세',
                    sideName: '브랜드관 상세',
                    name: 'BrandDetail',
                    sideHidden: true,
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            },
        ]
    },
    {
        path: '/review',
        component: setViewResolver('RouteView'),
        name: 'Review',
        beforeEnter: storeSet,
        meta: {
            title: '리뷰',
            sideName: '리뷰',
            icon_name: 'review',
            name: 'Theme',
            level: [2, 4, 5],
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true, levelCheck: true},
        },
        children: [
            {
                path: 'magazine',
                component: setViewResolver('review/ReviewMagazine'),
                name: 'ReviewMagazine',
                beforeEnter: storeSet,
                meta: {
                    title: '매거진 리뷰',
                    sideName: '매거진 리뷰',
                    name: '매거진 리뷰',
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            },
            {
                path: '',
                component: setViewResolver('review/ReviewProduct'),
                name: 'ReviewProduct',
                beforeEnter: storeSet,
                meta: {
                    title: '상품 리뷰',
                    sideName: '상품 리뷰',
                    name: 'Theme',
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            },
            {
                path: 'styling',
                component: setViewResolver('review/ReviewStyling'),
                name: 'ReviewStyling',
                beforeEnter: storeSet,
                meta: {
                    title: '스타일링 리뷰',
                    sideName: '스타일링 리뷰',
                    name: '스타일링 리뷰',
                    level: [2, 4, 5],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            },
            {
                path: 'magazine/:pr_idx',
                component: setViewResolver('review/ReviewMagazineDetail'),
                name: 'ReviewMagazineDetail',
                beforeEnter: storeSet,
                meta: {
                    title: '매거진 리뷰 상세',
                    sideName: '',
                    name: '매거진 리뷰 상세',
                    level: [2, 4, 5],
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            },
            {
                path: ':r_idx',
                component: setViewResolver('review/ReviewProductDetail'),
                name: 'ReviewProductDetail',
                beforeEnter: storeSet,
                meta: {
                    title: '상품 리뷰상세',
                    sideName: '상품 리뷰상세',
                    name: 'Theme',
                    level: [2, 4, 5],
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            },
            {
                path: 'styling/:rbs_idx',
                component: setViewResolver('review/ReviewStylingDetail'),
                name: 'ReviewStylingDetail',
                beforeEnter: storeSet,
                meta: {
                    title: '스타일링 리뷰 상세',
                    sideName: '스타일링 리뷰 상세',
                    name: 'Theme',
                    level: [2, 4, 5],
                    sideHidden: true,
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            },
        ]
    }, {
        path: '/custom',
        component: setViewResolver('RouteView'),
        name: 'custom',
        beforeEnter: storeSet,
        meta: {
            name: '',
            sideName: '고객센터',
            title: '고객센터',
            icon_name: 'service',
            level: [2, 3, 4],
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true, levelCheck: true},
        },
        children: [
            {
                path: 'faq',
                component: setViewResolver('faq/Faq'),
                name: 'Faq',
                beforeEnter: storeSet,
                meta: {
                    title: 'FAQ 리스트',
                    sideName: 'FAQ 리스트',
                    name: 'Faq',
                    level: [2, 3, 4],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                },
            }, {
                path: 'faq/create',
                component: setViewResolver('faq/FaqCreate'),
                name: 'FaqCreate',
                beforeEnter: storeSet,
                meta: {
                    title: 'FAQ 등록',
                    sideName: '',
                    sideHidden: true,
                    name: 'FaqCreate',
                    detail: true,
                    level: [2, 3, 4],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                },
            }, {
                path: 'faq/:fa_idx',
                component: setViewResolver('faq/FaqDetail'),
                name: 'FapDetail',
                beforeEnter: storeSet,
                meta: {
                    title: 'FAQ 수정',
                    sideName: '',
                    sideHidden: true,
                    name: 'FaqDetail',
                    detail: true,
                    level: [2, 3, 4],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            }, {
                path: 'qa',
                name: 'Qa',
                component: setViewResolver('qa/Qa'),
                beforeEnter: storeSet,
                meta: {
                    title: '일대일 문의 리스트',
                    sideName: '일대일 문의 리스트',
                    name: 'Qa',
                    level: [2, 3, 4],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true}
                },
            }, {
                path: 'qa/:qa_idx',
                component: setViewResolver('qa/QaDetail'),
                name: 'QaDetail',
                beforeEnter: storeSet,
                meta: {
                    title: '일대일 문의 등록/수정',
                    sideName: '',
                    sideHidden: true,
                    name: 'QaDetail',
                    detail: true,
                    level: [2, 3, 4],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true},
                }
            }, {
                path: 'notice',
                component: setViewResolver('notice/Notice'),
                name: 'Notice',
                beforeEnter: storeSet,
                meta: {
                    title: '공지사항 리스트',
                    sideName: '공지사항 리스트',
                    name: 'Notice',
                    level: [2, 3, 4],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true}
                },
            }, {
                path: 'notice/create',
                component: setViewResolver('notice/NoticeCreate'),
                name: 'NoticeCreate',
                beforeEnter: storeSet,
                meta: {
                    title: '공지사항 등록',
                    sideName: '',
                    sideHidden: true,
                    name: 'NoticeCreate',
                    detail: true,
                    level: [2, 3, 4],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true}
                }
            }, {
                path: 'notice/:wr_id',
                component: setViewResolver('notice/NoticeDetail'),
                name: 'NoticeDetail',
                beforeEnter: storeSet,
                meta: {
                    title: '공지사항 수정',
                    sideName: '',
                    sideHidden: true,
                    name: 'NoticeDetail',
                    detail: true,
                    level: [2, 3, 4],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true}
                }
            },
            {
                path: 'feedDeclaration',
                component: setViewResolver('declaration/FeedDeclaration'),
                name: 'FeedDeclaration',
                beforeEnter: storeSet,
                meta: {
                    title: '피드 게시판 신고 리스트',
                    sideName: '피드 게시판 신고 리스트',
                    name: 'FeedDeclaration',
                    level: [2, 3],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true}
                },
            },
            /*{
                path: 'todayDeclaration',
                component: setViewResolver('declaration/TodayDeclaration'),
                name: 'TodayDeclaration',
                beforeEnter: storeSet,
                meta: {title: '오늘 게시판 신고 리스트', sideName: '오늘 게시판 신고 리스트', name: 'TodayDeclaration',  level: [2, 3], authRequired: true, storeRequired: true, storeConfig:{userInfo:true, levelCheck: true}},
            },*/
            {
                path: 'userDeclaration',
                component: setViewResolver('declaration/UserDeclaration'),
                name: 'TodayDeclaration',
                beforeEnter: storeSet,
                meta: {
                    title: '사용자 신고 리스트',
                    sideName: '사용자 신고 리스트',
                    name: 'TodayDeclaration',
                    level: [2, 3],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true}
                },
            },
        ],
    },
    // {
    // path: '/declaration',
    // component: setViewResolver('RouteView'),
    // name: 'Declaration',
    // beforeEnter: storeSet,
    // meta: {name: 'Declaration', sideName: '신고', title: '신고', icon_name: 'service', level: [2, 3, 4], authRequired: true, storeRequired: true, storeConfig:{userInfo:true, levelCheck: true},},
    //     children: [
    //
    //     ]
    // },
    {
        path: '/info',
        component: setViewResolver('RouteView'),
        name: 'Info',
        beforeEnter: storeSet,
        meta: {
            title: '',
            sideName: '서비스 관리',
            icon_name: 'info-circle',
            level: [2],
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true, levelCheck: true}
        },
        children: [
            {
                path: 'adminInfo',
                name: 'AdminInfo',
                component: setViewResolver('info/AdminInfo'),
                beforeEnter: storeSet,
                meta: {
                    title: '기본정보 설정',
                    sideName: '기본정보 설정',
                    name: 'AdminInfo',
                    level: [2],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true}
                },
            },
            // {
            //     path: 'todayCategory',
            //     name: 'TodayCategory',
            //     component: setViewResolver('info/TodayCategory'),
            //     beforeEnter: storeSet,
            //     meta: {title: '오늘 카테고리 설정', sideName: '오늘 카테고리 설정', name: 'TodayCategory', level: [2], authRequired: true, storeRequired: true, storeConfig:{userInfo:true, levelCheck: true}},
            // },
            {
                path: 'terms',
                name: 'Terms',
                component: setViewResolver('info/Terms'),
                beforeEnter: storeSet,
                meta: {
                    title: '약관 및 정책설정',
                    sideName: '약관및정책설정',
                    name: 'Terms',
                    level: [2],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true}
                },
            },

            {
                path: 'site',
                name: 'Site',
                component: setViewResolver('info/Site'),
                beforeEnter: storeSet,
                meta: {
                    title: '사이트설정',
                    sideName: '사이트설정',
                    name: 'Site',
                    level: [2],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true}
                },
            },

            /* {
                 path: 'push',
                 name: 'Push',
                 component: setViewResolver('info/Push'),
                 beforeEnter: storeSet,
                 meta: {title: '푸시전송', sideName: '푸시전송', name: 'Push', level: [2], authRequired: true, storeRequired: true, storeConfig:{userInfo:true, levelCheck: true}},
             },*/
            {
                path: 'store',
                name: 'Store',
                component: setViewResolver('info/store/Store'),
                beforeEnter: storeSet,
                meta: {
                    title: '스토어설정',
                    sideName: '스토어설정',
                    name: 'Store',
                    level: [2],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true}
                },

            },
            {
                path: 'store/create',
                component: setViewResolver('info/store/StoreCreate'),
                name: 'StoreCreate',
                beforeEnter: storeSet,
                meta: {
                    title: '스토어 등록',
                    sideName: '',
                    sideHidden: true,
                    name: 'StoreDetail',
                    level: [2],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true}
                }
            },
            {
                path: 'store/:s_idx',
                component: setViewResolver('info/store/StoreDetail'),
                name: 'StoreDetail',
                beforeEnter: storeSet,
                meta: {
                    title: '스토어 상세',
                    sideName: '',
                    sideHidden: true,
                    name: 'StoreDetail',
                    level: [2],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true}
                }
            },
            {
                path: 'point',
                name: 'Point',
                component: setViewResolver('info/point/Point'),
                beforeEnter: storeSet,
                meta: {
                    title: '포인트 전환 신청 내역',
                    sideName: '포인트전환신청',
                    name: 'Point',
                    level: [2],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true}
                },

            },
            {
                path: 'point/setting',
                name: 'PointSetting',
                component: setViewResolver('info/point/PointSetting'),
                beforeEnter: storeSet,
                meta: {
                    title: '포인트 지급 설정',
                    sideName: '포인트 지급 설정',
                    name: 'Point',
                    level: [2],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true}
                },

            },
        ]
    },
    {
        path: '/mall',
        component: setViewResolver('RouteView'),
        name: 'Mall',
        beforeEnter: storeSet,
        meta: {
            title: '',
            sideName: '몰 관리',
            icon_name: 'cart',
            level: [2],
            authRequired: true,
            storeRequired: true,
            storeConfig: {userInfo: true, levelCheck: true}
        },
        children: [
            {
                path: 'delivery',
                name: 'Delivery',
                component: setViewResolver('mall/Delivery'),
                beforeEnter: storeSet,
                meta: {
                    title: '배송비 설정',
                    sideName: '배송비 설정',
                    name: 'Delivery',
                    level: [2],
                    authRequired: true,
                    storeRequired: true,
                    storeConfig: {userInfo: true, levelCheck: true}
                },
            },
        ]
    },
    // {
    //     path: '/accuracy',
    //     component: setViewResolver('RouteView'),
    //     name: 'menu',
    //     beforeEnter: storeSet,
    //     meta: {
    //         title: '',
    //         sideName: '정확도 리스트',
    //         icon_name: 'Delivery',
    //         level: [2],
    //         authRequired: true,
    //         storeRequired: true,
    //         storeConfig: {userInfo: true, levelCheck: true}
    //     },
    //     children: [
    //         {
    //             path: 'image',
    //             name: 'Image',
    //             component: setViewResolver('accuracy/Image'),
    //             beforeEnter: storeSet,
    //             meta: {
    //                 title: '이미지 인식 정확도 리스트',
    //                 sideName: '이미지 인식 정확도 리스트',
    //                 name: 'Price',
    //                 level: [2],
    //                 authRequired: true,
    //                 storeRequired: true,
    //                 storeConfig: {userInfo: true, levelCheck: true}
    //             },
    //         },
    //         {
    //             path: 'price',
    //             name: 'Price',
    //             component: setViewResolver('accuracy/Price'),
    //             beforeEnter: storeSet,
    //             meta: {
    //                 title: '메뉴 항목 가격 리스트',
    //                 sideName: '메뉴 항목 가격 리스트',
    //                 name: 'Price',
    //                 level: [2],
    //                 authRequired: true,
    //                 storeRequired: true,
    //                 storeConfig: {userInfo: true, levelCheck: true}
    //             },
    //         },
    //     ]
    // },
    {
        path: '/test',
        component: setViewResolver('test/NewFilterTest'),
        name: 'NewFilterTest',
        meta: {title: '', sideName: '테스트', icon_name: 'Info', sideHidden: true,},
    },
    {
        path: '/policy',
        component: setViewResolver('policy/Policy'),
        name: 'Policy',
        meta: {title: '개인정보 취급방침', sideName: '개인정보 취급방침', icon_name: 'Info', sideHidden: true,},
    },

]
